<template>
  <div class="indicadores-report">
    <!-- Slide 1: Capa (imagem) -->
    <div class="slide slide-capa">
      <img
        src="@/assets/indicadores-capa.svg"
        alt="Indicadores Semanais"
        class="capa-img"
      />
    </div>
	<!-- Slide 2: Registros DIs/DUIMPs mensal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="legend" style="margin-top:12px;">
		  <div class="legend-item"><div class="legend-dot" style="background:#1B3A6B;"></div>Prime</div>
          <div class="legend-item"><div class="legend-dot" style="background:#6B6B6B;"></div>Itacex</div>
          <div class="legend-item"><div class="legend-dot" style="background:#5BC4EC;"></div>Inova</div>
          <div class="legend-item"><div class="legend-dot" style="background:#F5C842;"></div>Outras</div>
        </div>
        <div class="slide-flex" style="gap:30px; margin-top:16px; align-items:flex-start;">
          <div style="flex:1; height:480px; position:relative;">
            <canvas ref="chartMensal"></canvas>
            <img v-if="pdfMode && chartImages.chartMensal" :src="chartImages.chartMensal" alt="" class="chart-pdf-img">
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 3: Donuts Fevereiro + Março -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
		<div class="legend" style="margin-top:12px;">
		  <div class="legend-item"><div class="legend-dot" style="background:#1B3A6B;"></div>Prime</div>
          <div class="legend-item"><div class="legend-dot" style="background:#6B6B6B;"></div>Itacex</div>
          <div class="legend-item"><div class="legend-dot" style="background:#5BC4EC;"></div>Inova</div>
          <div class="legend-item"><div class="legend-dot" style="background:#F5C842;"></div>Outras</div>
        </div>
        <div class="slide-flex" style="gap:40px; margin-top:20px; align-items:flex-start; justify-content:center;">
          <div style="flex:1; display:flex; flex-direction:column; align-items:center;">
            <div style="width:380px; height:380px; position:relative;">
              <canvas ref="chartDonutFev"></canvas>
              <img v-if="pdfMode && chartImages.chartDonutFev" :src="chartImages.chartDonutFev" alt="" class="chart-pdf-img">
            </div>
            <div style="font-size:20px; font-weight:700; color:#2B6BDB; margin-top:10px;">{{ donutFirstMonthLabel }} ({{ donutFirstMonthTotal }})</div>
          </div>
          <div style="flex:1; display:flex; flex-direction:column; align-items:center;">
            <div style="width:380px; height:380px; position:relative;">
              <canvas ref="chartDonutMar"></canvas>
              <img v-if="pdfMode && chartImages.chartDonutMar" :src="chartImages.chartDonutMar" alt="" class="chart-pdf-img">
            </div>
            <div style="font-size:18px; font-weight:700; color:#C9930F; margin-top:10px;">{{ donutSecondMonthLabel }} ({{ donutSecondMonthTotal }})</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 4: Registros DIs/DUIMPs Semanal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Semanal</div>
        <div class="legend" style="margin-top:10px;">
		  <div class="legend-item"><div class="legend-dot" style="background:#1B3A6B;"></div>Prime</div>
          <div class="legend-item"><div class="legend-dot" style="background:#6B6B6B;"></div>Itacex</div>
          <div class="legend-item"><div class="legend-dot" style="background:#5BC4EC;"></div>Inova</div>
          <div class="legend-item"><div class="legend-dot" style="background:#F5C842;"></div>Outras</div>
        </div>
        <div style="height:480px; position:relative; margin-top:14px;">
          <canvas ref="chartSemanal"></canvas>
          <img v-if="pdfMode && chartImages.chartSemanal" :src="chartImages.chartSemanal" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

    <!-- Slide 5: Evolução Prime -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 60px;">
        <div class="title-main">Evolução Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Prime</div>
        <div style="height:520px; position:relative; margin-top:18px;">
          <canvas ref="chartEvolucao"></canvas>
          <img v-if="pdfMode && chartImages.chartEvolucao" :src="chartImages.chartEvolucao" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

    <!-- Slide 6: Mensal por analista -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Mensal por analista</div>
        <div class="legend" style="margin-top:8px;">
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--adriani" style="border-color:#48b3fb;" aria-hidden="true"></div>
            Imp 1
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--mariane" style="border-color:#C9930F;" aria-hidden="true"></div>
            Imp 2
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--felipe" style="border-color:#1b4274;" aria-hidden="true"></div>
            Imp 3
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--cami" style="border-color:#656766;" aria-hidden="true"></div>
            Imp 4
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--maria-gabriela" style="border-color:#ffde59;" aria-hidden="true"></div>
            Imp 5
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--laura" style="border-color:#F4B8C8;" aria-hidden="true"></div>
            Imp 6
          </div>
        </div>
        <div style="height:490px; position:relative; margin-top:14px;">
          <canvas ref="chartMensalAnalista"></canvas>
          <img v-if="pdfMode && chartImages.chartMensalAnalista" :src="chartImages.chartMensalAnalista" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

    <!-- Slide 9: Semanal por analista -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 36px;">
        <div class="title-main" style="padding-top: 30px;">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Semanal por analista</div>
		<div class="legend" style="margin-top:8px;">
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--adriani" style="border-color:#48b3fb;" aria-hidden="true"></div>
            Imp 1
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--mariane" style="border-color:#C9930F;" aria-hidden="true"></div>
            Imp 2
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--felipe" style="border-color:#1b4274;" aria-hidden="true"></div>
            Imp 3
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--cami" style="border-color:#656766;" aria-hidden="true"></div>
            Imp 4
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--maria-gabriela" style="border-color:#ffde59;" aria-hidden="true"></div>
            Imp 5
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--laura" style="border-color:#F4B8C8;" aria-hidden="true"></div>
            Imp 6
          </div>
        </div>
        <div style="height:475px; position:relative; margin-top:12px;">
          <canvas ref="chartSemanalAnalista"></canvas>
          <img v-if="pdfMode && chartImages.chartSemanalAnalista" :src="chartImages.chartSemanalAnalista" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

	   <!-- Slide 7: Mensal por time aduaneiro -->
	<div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main" style="padding-top: 30px;">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Mensal por time aduaneiro</div>
		<div class="legend" style="margin-top:12px;">
		  <div class="legend-item"><div class="legend-dot" style="background:#1B4274;"></div>Aduaneiro 1</div>
          <div class="legend-item"><div class="legend-dot" style="background:#C9930F;"></div>Aduaneiro 2</div>
          <div class="legend-item"><div class="legend-dot" style="background:#656766;"></div>Aduaneiro 3</div>
        </div>
        <div style="height:490px; position:relative; margin-top:14px;">
          <canvas ref="chartMensalCustomsTeam"></canvas>
          <img v-if="pdfMode && chartImages.chartMensalCustomsTeam" :src="chartImages.chartMensalCustomsTeam" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

    <!-- Slide 8: Mensal por time aduaneiro - Prime -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 40px;">
        <div class="title-main" style="padding-top: 30px;">Registros de <span class="title-main-dis-duimp">DIs / DUIMPs</span></div>
        <div class="title-sub">Mensal por time aduaneiro - Prime</div>
        <div class="legend" style="margin-top:12px;">
		  <div class="legend-item"><div class="legend-dot" style="background:#1B4274;"></div>Aduaneiro 1</div>
          <div class="legend-item"><div class="legend-dot" style="background:#C9930F;"></div>Aduaneiro 2</div>
          <div class="legend-item"><div class="legend-dot" style="background:#656766;"></div>Aduaneiro 3</div>
        </div>
        <div style="height:490px; position:relative; margin-top:14px;">
          <canvas ref="chartMensalCustomsTeamPrime"></canvas>
          <img v-if="pdfMode && chartImages.chartMensalCustomsTeamPrime" :src="chartImages.chartMensalCustomsTeamPrime" alt="" class="chart-pdf-img">
        </div>
      </div>
    </div>

    <!-- Slide 8: Abertura Mensal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 50px;">
        <div class="title-main">Abertura de Processos</div>
        <div class="title-sub">Mensal</div>
        <div class="slide-flex" style="gap:40px; margin-top:24px; align-items:center;">
          <div style="flex:1.4; height:380px; position:relative;">
            <canvas ref="chartAberturaMensal"></canvas>
            <img v-if="pdfMode && chartImages.chartAberturaMensal" :src="chartImages.chartAberturaMensal" alt="" class="chart-pdf-img">
          </div>
          <div style="width:280px; display:flex; flex-direction:column; gap:16px;">
            <div class="highlight-box box-navy" style="font-size:14px; line-height:1.5; font-weight:400; padding:16px 18px;">
              {{ highlightsAberturaMensal.text }}
            </div>
            <div class="highlight-box box-bright-blue" style="padding:20px 22px; text-align:center;">
              <div style="font-size:26px; font-weight:700; margin-bottom:6px;">Média Mensal</div>
              <div style="font-size:25px; font-weight:600;">{{ aberturaMensalMediaBox.prevYear }} =&gt; {{ aberturaMensalMediaBox.prevAvg }}</div>
              <div style="font-size:25px; font-weight:600; margin-top:4px;">{{ aberturaMensalMediaBox.curYear }} =&gt; {{ aberturaMensalMediaBox.curAvg }}*</div>
			  <div style="font-size:12px; font-weight:400;">*Mês atual não incluído no cálculo.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 9: Abertura Semanal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 50px;">
        <div class="title-main">Abertura de Processos</div>
        <div class="title-sub">Semanal</div>
        <div class="slide-flex" style="gap:40px; margin-top:24px; align-items:center;">
          <div style="flex:1.6; height:460px; position:relative;">
            <canvas ref="chartAberturaSemanal"></canvas>
            <img v-if="pdfMode && chartImages.chartAberturaSemanal" :src="chartImages.chartAberturaSemanal" alt="" class="chart-pdf-img">
          </div>
          <div style="width:250px; display:flex; flex-direction:column; gap:16px;">
            <div class="highlight-box box-navy" style="padding:20px 22px;">
              <div class="big-pct">{{ highlightsAberturaSemanal.pctLabel }}</div>
              <div class="small-text">{{ highlightsAberturaSemanal.line2 }}</div>
            </div>
            <div class="highlight-box box-bright-blue" style="padding:20px 22px; text-align:center;">
              <div style="font-size:26px; font-weight:700; margin-bottom:6px;">Média Semanal</div>
              <div style="font-size:25px; font-weight:600;">{{ aberturaSemanalMediaBox.prevYear }} =&gt; {{ aberturaSemanalMediaBox.prevAvg }}</div>
              <div style="font-size:25px; font-weight:600; margin-top:4px;">{{ aberturaSemanalMediaBox.curYear }} =&gt; {{ aberturaSemanalMediaBox.curAvg }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 10: Encerramento Mensal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 50px;">
        <div class="title-main">Encerramento de Processos</div>
        <div class="title-sub">Mensal</div>
        <div class="slide-flex" style="gap:40px; margin-top:24px; align-items:center;">
          <div style="flex:1.4; height:380px; position:relative;">
            <canvas ref="chartEncerramentoMensal"></canvas>
            <img v-if="pdfMode && chartImages.chartEncerramentoMensal" :src="chartImages.chartEncerramentoMensal" alt="" class="chart-pdf-img">
          </div>
          <div style="width:280px; display:flex; flex-direction:column; gap:16px;">
            <div class="highlight-box box-navy" style="font-size:14px; line-height:1.5; font-weight:400; padding:16px 18px;">
              {{ highlightsEncerramentoMensal.text }}
            </div>
            <div class="highlight-box box-bright-blue" style="padding:20px 22px; text-align:center;">
              <div style="font-size:26px; font-weight:700; margin-bottom:6px;">Média Mensal</div>
              <div style="font-size:25px; font-weight:600;">{{ encerramentoMensalMediaBox.prevYear }} =&gt; {{ encerramentoMensalMediaBox.prevAvg }}</div>
              <div style="font-size:25px; font-weight:600; margin-top:4px;">{{ encerramentoMensalMediaBox.curYear }} =&gt; {{ encerramentoMensalMediaBox.curAvg }}*</div>
			  <div style="font-size:12px; font-weight:400; ">*Mês atual não incluído no cálculo.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 11: Encerramentos Semanal -->
    <div class="slide">
      <div class="slide-inner" style="padding: 0 50px;">
        <div class="title-main">Encerramentos de Processos</div>
        <div class="title-sub">Semanal</div>
        <div class="slide-flex" style="gap:40px; margin-top:24px; align-items:center;">
          <div style="flex:1.6; height:460px; position:relative;">
            <canvas ref="chartEncerramentoSemanal"></canvas>
            <img v-if="pdfMode && chartImages.chartEncerramentoSemanal" :src="chartImages.chartEncerramentoSemanal" alt="" class="chart-pdf-img">
          </div>
          <div style="width:250px; display:flex; flex-direction:column; gap:16px;">
            <div class="highlight-box box-navy" style="padding:20px 22px;">
              <div class="big-pct">{{ highlightsEncerramentoSemanal.pctLabel }}</div>
              <div class="small-text">{{ highlightsEncerramentoSemanal.line2 }}</div>
            </div>
            <div class="highlight-box box-bright-blue" style="padding:20px 22px; text-align:center;">
              <div style="font-size:26px; font-weight:700; margin-bottom:6px;">Média Semanal</div>
              <div style="font-size:25px; font-weight:600;">{{ encerramentoSemanalMediaBox.prevYear }} =&gt; {{ encerramentoSemanalMediaBox.prevAvg }}</div>
              <div style="font-size:25px; font-weight:600; margin-top:4px;">{{ encerramentoSemanalMediaBox.curYear }} =&gt; {{ encerramentoSemanalMediaBox.curAvg }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 12: Chegadas Semana 12 -->
    <div class="slide modify-slide">
      <div class="slide-inner" style="padding: 0 40px; height:100%; display:flex; flex-direction:column; align-items:center;">
        <div class="title-main" style="width:100%;">Chegadas</div>
        <div class="title-sub" style="width:100%;">
          <template v-if="chegadasSemanaLabelExtra">{{ chegadasSemanaLabelExtra }} - {{ chegadasSemanaLabel }} </template>
          <template v-else>{{ chegadasSemanaLabel }}</template>
        </div>
		<div class="legend" style="margin-top:8px;">
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--adriani" style="border-color:#48b3fb;" aria-hidden="true"></div>
            Imp 1
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--mariane" style="border-color:#C9930F;" aria-hidden="true"></div>
            Imp 2
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--felipe" style="border-color:#1b4274;" aria-hidden="true"></div>
            Imp 3
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--cami" style="border-color:#656766;" aria-hidden="true"></div>
            Imp 4
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--maria-gabriela" style="border-color:#ffde59;" aria-hidden="true"></div>
            Imp 5
          </div>
          <div class="legend-item">
            <div class="legend-avatar legend-avatar--laura" style="border-color:#F4B8C8;" aria-hidden="true"></div>
            Imp 6
          </div>
        </div>
        <div style="display:flex; flex-direction:column; align-items:center; margin-top:10px;">
          <div style="width:460px; height:460px; position:relative;">
            <canvas ref="chartChegadas"></canvas>
            <img v-if="pdfMode && chartImages.chartChegadas" :src="chartImages.chartChegadas" alt="" class="chart-pdf-img">
          </div>
          <div style="font-size:18px; font-weight:700; color:#C9930F; margin-top:10px;">{{ chegadasSemanaCaption }}</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables, ChartDataLabels);
Chart.defaults.font.family = 'Poppins';
Chart.defaults.plugins.legend.display = false;
Chart.defaults.plugins.datalabels.display = true;

const COLORS = {
  inova: '#5BC4EC',
  itacex: '#6B6B6B',
  prime: '#1B3A6B',
  outras: '#F5C842',
  imp1: '#5BC4EC',
  imp24: '#6B6B6B',
  imp2: '#C9930F',
  imp3: '#1B3A6B',
  imp5: '#F5C842',
  imp6: '#F4B8C8',
  navy: '#1B3A6B',
  pink: '#F4B8C8',
  amber: '#C9930F',
};

const CHART_REF_NAMES = [
  'chartMensal',
  'chartDonutFev',
  'chartDonutMar',
  'chartSemanal',
  'chartEvolucao',
  'chartMensalAnalista',
  'chartMensalCustomsTeam',
  'chartMensalCustomsTeamPrime',
  'chartSemanalAnalista',
  'chartAberturaMensal',
  'chartAberturaSemanal',
  'chartEncerramentoMensal',
  'chartEncerramentoSemanal',
  'chartChegadas',
];

function pickColor(hex, fallback) {
  return hex && String(hex).trim() ? hex : fallback;
}

function maxInArrays(arrays) {
  let m = 0;
  arrays.forEach((arr) => {
    (arr || []).forEach((v) => {
      const n = Number(v);
      if (!Number.isNaN(n) && n > m) m = n;
    });
  });
  return m;
}

function niceCeilMax(value, defaultMax) {
  if (!value || value <= 0) return defaultMax;
  const padded = Math.ceil(value * 1.12);
  return Math.max(padded, defaultMax);
}

function countAt(series, monthIdx) {
  const v = series && series.counts && series.counts[monthIdx];
  const num = Number(v);
  return Number.isNaN(num) ? 0 : num;
}

/** Médias anuais vindas da API (page7 etc.): número válido ou null. */
function numericOrNull(v) {
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

/** Lê averagePreviousYear / averageCurrentYear (camelCase ou snake_case do JSON). */
function yearAveragesFromPage(page) {
  if (!page) return { prev: null, cur: null };
  const prev = numericOrNull(page.averagePreviousYear ?? page.average_previous_year);
  const cur = numericOrNull(page.averageCurrentYear ?? page.average_current_year);
  return { prev, cur };
}

function yearLabelsFromPage(page) {
  const yPrevRaw = page && (page.previousYear ?? page.previous_year);
  const yCurRaw = page && (page.currentYear ?? page.current_year);
  const yPrev = yPrevRaw != null && !Number.isNaN(Number(yPrevRaw))
    ? Number(yPrevRaw)
    : new Date().getFullYear() - 1;
  const yCur = yCurRaw != null && !Number.isNaN(Number(yCurRaw))
    ? Number(yCurRaw)
    : new Date().getFullYear();
  return { yPrev, yCur };
}

function stripDiacritics(str) {
  return String(str)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Três primeiras letras do mês em PT (sem acento) → índice 0–11. */
const MONTH_ABBR_PT = {
  jan: 0,
  fev: 1,
  mar: 2,
  abr: 3,
  mai: 4,
  jun: 5,
  jul: 6,
  ago: 7,
  set: 8,
  out: 9,
  nov: 10,
  dez: 11,
};

function expandTwoDigitYear(yy, refYear) {
  if (yy >= 100) return yy;
  const c = Math.floor(refYear / 100) * 100;
  let y = c + yy;
  if (y > refYear + 50) y -= 100;
  if (y < refYear - 50) y += 100;
  return y;
}

/**
 * Interpreta rótulo mensal dos gráficos gerenciais (ex.: page7 Abertura, page9 Encerramento) para { y, m } com m = 0..11.
 * Sem ano explícito usa currentYear da página.
 */
function parseMonthYearFromManagerialMonthLabel(label, page) {
  const raw = String(label || '').trim();
  if (!raw) return null;
  const { yCur } = yearLabelsFromPage(page);
  const s = stripDiacritics(raw.toLowerCase());

  const mmYyyy = s.match(/^(\d{1,2})\/(\d{4})$/);
  if (mmYyyy) {
    const m = Number(mmYyyy[1]) - 1;
    const y = Number(mmYyyy[2]);
    if (m >= 0 && m <= 11) return { y, m };
    return null;
  }

  const mmYy = s.match(/^(\d{1,2})\/(\d{2})$/);
  if (mmYy) {
    const mo = Number(mmYy[1]);
    const yy = Number(mmYy[2]);
    if (mo >= 1 && mo <= 12) {
      return { y: expandTwoDigitYear(yy, yCur), m: mo - 1 };
    }
    return null;
  }

  const iso = s.match(/^(\d{4})-(\d{2})(?:-\d{2})?$/);
  if (iso) {
    const y = Number(iso[1]);
    const m = Number(iso[2]) - 1;
    if (m >= 0 && m <= 11) return { y, m };
    return null;
  }

  const monSlash = s.match(/^([a-z]{3,})\/(\d{2,4})$/);
  if (monSlash) {
    const pref = monSlash[1].slice(0, 3);
    const mi = MONTH_ABBR_PT[pref];
    if (mi == null) return null;
    const yStr = monSlash[2];
    const yNum = Number(yStr);
    const y = yStr.length <= 2 ? expandTwoDigitYear(yNum, yCur) : yNum;
    return { y, m: mi };
  }

  const letters = s.match(/^([a-z]{3,})$/);
  if (letters) {
    const pref = letters[1].slice(0, 3);
    const mi = MONTH_ABBR_PT[pref];
    if (mi == null) return null;
    return { y: yCur, m: mi };
  }

  return null;
}

/** Última barra é o mês civil atual ainda em curso (parcial). */
function isLastManagerialMonthBarCurrentIncompleteMonth(page, lastLabel) {
  const parsed = parseMonthYearFromManagerialMonthLabel(lastLabel, page);
  if (!parsed) return false;
  const now = new Date();
  return parsed.y === now.getFullYear() && parsed.m === now.getMonth();
}

/** Escala horizontal com max e step inteiros (evita ticks decimais no eixo X). */
function horizontalBarAxisScale(counts, defaultMax, stepUnit = 50) {
  const maxVal = maxInArrays([counts]);
  const padded = niceCeilMax(maxVal, defaultMax);
  const step = Math.max(stepUnit, Math.ceil(padded / 5 / stepUnit) * stepUnit);
  const xMax = Math.max(step, Math.ceil(padded / step) * step);
  return { xMax, step };
}

/**
 * Média do ano atual (currentYear da página) a partir dos pontos do relatório (labels + counts).
 * Se a última barra for o mês civil atual ainda em curso, esse ponto não entra no cálculo.
 */
function currentYearAverageFromManagerialSeries(page) {
  if (!page || !page.labels || !page.series || !page.series.length) {
    return null;
  }
  const s0 = page.series[0];
  const counts = s0.counts || [];
  const labels = page.labels;
  const len = Math.min(counts.length, labels.length);
  if (len === 0) return null;
  const lastLabel = labels[len - 1];
  let effectiveLen = len;
  if (isLastManagerialMonthBarCurrentIncompleteMonth(page, lastLabel)) {
    effectiveLen = len - 1;
  }
  if (effectiveLen <= 0) return null;
  const { yCur } = yearLabelsFromPage(page);
  let sum = 0;
  let n = 0;
  for (let i = 0; i < effectiveLen; i += 1) {
    const parsed = parseMonthYearFromManagerialMonthLabel(labels[i], page);
    if (!parsed || parsed.y !== yCur) continue;
    sum += countAt(s0, i);
    n += 1;
  }
  return n > 0 ? sum / n : null;
}

function monthGrandTotal(page, monthIdx) {
  if (!page || !page.series) return 0;
  return page.series.reduce((sum, s) => sum + countAt(s, monthIdx), 0);
}

const DONUT_EMPTY_RING_COLOR = '#e8e8e8';

const donutCenterZeroPlugin = {
  id: 'donutCenterZero',
  afterDraw(chart) {
    const meta = chart.getDatasetMeta(0);
    if (!meta || !meta.data || !meta.data[0]) return;
    const { x, y } = meta.data[0];
    const { ctx } = chart;
    ctx.save();
    ctx.font = '700 28px Poppins, Arial, sans-serif';
    ctx.fillStyle = '#666';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('0', x, y);
    ctx.restore();
  },
};

function createManagerialDonutChart(canvas, labels, data, backgroundColor, layoutPadding = 60) {
  const total = data.reduce((sum, v) => sum + (Number(v) || 0), 0);
  const isEmpty = total === 0;

  const chartData = isEmpty
    ? {
        labels: [''],
        datasets: [{
          data: [1],
          backgroundColor: [DONUT_EMPTY_RING_COLOR],
          borderWidth: 2,
          borderColor: '#fff',
        }],
      }
    : {
        labels,
        datasets: [{
          data,
          backgroundColor,
          borderWidth: 2,
          borderColor: '#fff',
        }],
      };

  const datalabelsConfig = isEmpty
    ? { display: false }
    : {
        anchor: 'end',
        align: 'end',
        offset: 12,
        font: { size: 14, weight: '700' },
        color: '#333',
        formatter: (value, ctx) => ctx.chart.data.labels[ctx.dataIndex] + '\n' + value,
        textAlign: 'center',
      };

  return new Chart(canvas.getContext('2d'), {
    type: 'doughnut',
    data: chartData,
    plugins: isEmpty ? [donutCenterZeroPlugin] : [],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '55%',
      layout: { padding: layoutPadding },
      plugins: {
        datalabels: datalabelsConfig,
      },
    },
  });
}

/** Variação percentual de a → b; pct sempre ≥ 0 para exibição. */
function pctChangeMeta(a, b) {
  if (a === 0 && b === 0) return { pct: 0, kind: 'flat' };
  if (a === 0) return { pct: b !== 0 ? 100 : 0, kind: b > 0 ? 'up' : 'flat' };
  const raw = ((b - a) / a) * 100;
  const pct = Math.round(Math.abs(raw));
  if (raw > 0) return { pct, kind: 'up' };
  if (raw < 0) return { pct, kind: 'down' };
  return { pct: 0, kind: 'flat' };
}

export default {
  name: 'IndicadoresReport',
  data() {
    return {
      charts: [],
      pdfMode: false,
      chartImages: {},
    };
  },
  props: {
    managerial: {
      type: Object,
      required: true,
    },
  },
  computed: {
    pages() {
      return (this.managerial && this.managerial.pages) || {};
    },
    chegadasSemanaLabel() {
      const p = this.pages.page11;
      if (p && p.labels && p.labels.length) return p.labels[0];
      return 'Semana 12';
    },
    chegadasSemanaLabelExtra() {
      const p = this.pages.page11;
      if (!p || !p.labelsExtra || !p.labelsExtra.length) return '';
      const e = p.labelsExtra[0];
      if (e == null || String(e).trim() === '') return '';
      return String(e);
    },
    chegadasSemanaTotal() {
      const p = this.pages.page11;
      if (!p || !p.labels || !p.labels.length) return 0;
      return monthGrandTotal(p, 0);
    },
    chegadasSemanaCaption() {
      const label = this.chegadasSemanaLabel;
      const extra = this.chegadasSemanaLabelExtra;
      const total = this.chegadasSemanaTotal;
      if (extra) return `${extra} - ${label} (${total})`;
      return `${label} (${total})`;
    },
    /** Meses dos donuts (page2): mesmos índices de chartDonutFev / chartDonutMar. */
    donutFirstMonthLabel() {
      const p = this.pages.page2;
      if (p && p.labels && p.labels.length >= 1) return p.labels[0];
      return '';
    },
    donutSecondMonthLabel() {
      const p = this.pages.page2;
      if (p && p.labels && p.labels.length >= 2) return p.labels[1];
      return '';
    },
    donutFirstMonthTotal() {
      const p = this.pages.page2;
      if (!p || !p.labels || p.labels.length < 1) return 0;
      return monthGrandTotal(p, 0);
    },
    donutSecondMonthTotal() {
      const p = this.pages.page2;
      if (!p || !p.labels || p.labels.length < 2) return 0;
      return monthGrandTotal(p, 1);
    },
    /** Slide Abertura Mensal (page7): penúltimo vs último mês fechado; se o último for o mês civil atual (parcial), usa os dois anteriores. */
    highlightsAberturaMensal() {
      const page = this.pages.page7;
      if (!page || !page.labels || !page.series || !page.series.length) {
        return { text: 'Dados insuficientes para este destaque.' };
      }
      const s0 = page.series[0];
      const counts = s0.counts || [];
      const labels = page.labels;
      const len = Math.min(counts.length, labels.length);
      if (len < 2) {
        return { text: 'Dados insuficientes para este destaque.' };
      }
      const lastLabel = labels[len - 1];
      let iPen;
      let iUlt;
      if (isLastManagerialMonthBarCurrentIncompleteMonth(page, lastLabel)) {
        if (len < 3) {
          return { text: 'Dados insuficientes para este destaque.' };
        }
        iPen = len - 3;
        iUlt = len - 2;
      } else {
        iPen = len - 2;
        iUlt = len - 1;
      }
      const a = countAt(s0, iPen);
      const b = countAt(s0, iUlt);
      const m0 = labels[iPen];
      const m1 = labels[iUlt];
      const { pct, kind } = pctChangeMeta(a, b);
      let text;
      if (kind === 'up') {
        text = `${pct}% de crescimento na abertura de processos entre ${m0} e ${m1}.`;
      } else if (kind === 'down') {
        text = `${pct}% de redução na abertura de processos entre ${m0} e ${m1}.`;
      } else {
        text = `Abertura de Processos estável entre ${m0} e ${m1}, similar aos meses anteriores.`;
      }
      return { text };
    },
    /** Rótulos e valores da caixa Média Mensal (page7). */
    aberturaMensalMediaBox() {
      const page = this.pages.page7;
      const { prev } = yearAveragesFromPage(page);
      const cur = currentYearAverageFromManagerialSeries(page);
      const { yPrev, yCur } = yearLabelsFromPage(page);
      return {
        prevYear: yPrev,
        curYear: yCur,
        prevAvg: prev != null ? String(Math.round(prev)) : '—',
        curAvg: cur != null ? String(Math.round(cur)) : '—',
      };
    },
    /** Slide Abertura Semanal (page8): último vs penúltimo ponto do gráfico (big-pct + legenda). */
    highlightsAberturaSemanal() {
      const page = this.pages.page8;
      if (!page || !page.labels || !page.series || !page.series.length) {
        return { pctLabel: '—', line2: 'Dados insuficientes para este destaque.' };
      }
      const s0 = page.series[0];
      const counts = s0.counts || [];
      const labels = page.labels;
      const len = Math.min(counts.length, labels.length);
      if (len < 2) {
        return { pctLabel: '—', line2: 'Dados insuficientes para este destaque.' };
      }
      const iPen = len - 2;
      const iUlt = len - 1;
      const a = countAt(s0, iPen);
      const b = countAt(s0, iUlt);
      const m0 = labels[iPen];
      const m1 = labels[iUlt];
      const { pct, kind } = pctChangeMeta(a, b);
      const pctLabel = kind === 'flat' && a === 0 && b === 0 ? '0%' : `${pct}%`;
      let line2;
      if (kind === 'up') {
        line2 = `de crescimento na abertura de processos entre ${m0} e ${m1}.`;
      } else if (kind === 'down') {
        line2 = `de redução na abertura de processos entre ${m0} e ${m1}.`;
      } else {
        line2 = `Abertura de processos estável entre ${m0} e ${m1}.`;
      }
      return { pctLabel, line2 };
    },
    /** Caixa Média Semanal (page8): averagePreviousYear / averageCurrentYear da API. */
    aberturaSemanalMediaBox() {
      const page = this.pages.page8;
      const { prev, cur } = yearAveragesFromPage(page);
      const { yPrev, yCur } = yearLabelsFromPage(page);
      return {
        prevYear: yPrev,
        curYear: yCur,
        prevAvg: prev != null ? String(Math.round(prev)) : '—',
        curAvg: cur != null ? String(Math.round(cur)) : '—',
      };
    },
    /** Slide Encerramento Mensal (page9): penúltimo vs último mês fechado; se o último for o mês civil atual (parcial), usa os dois anteriores. */
    highlightsEncerramentoMensal() {
      const page = this.pages.page9;
      if (!page || !page.labels || !page.series || !page.series.length) {
        return { text: 'Dados insuficientes para este destaque.' };
      }
      const s0 = page.series[0];
      const counts = s0.counts || [];
      const labels = page.labels;
      const len = Math.min(counts.length, labels.length);
      if (len < 2) {
        return { text: 'Dados insuficientes para este destaque.' };
      }
      const lastLabel = labels[len - 1];
      let iPen;
      let iUlt;
      if (isLastManagerialMonthBarCurrentIncompleteMonth(page, lastLabel)) {
        if (len < 3) {
          return { text: 'Dados insuficientes para este destaque.' };
        }
        iPen = len - 3;
        iUlt = len - 2;
      } else {
        iPen = len - 2;
        iUlt = len - 1;
      }
      const a = countAt(s0, iPen);
      const b = countAt(s0, iUlt);
      const m0 = labels[iPen];
      const m1 = labels[iUlt];
      const { pct, kind } = pctChangeMeta(a, b);
      let text;
      if (kind === 'up') {
        text = `${pct}% de crescimento no encerramento de processos entre ${m0} e ${m1}.`;
      } else if (kind === 'down') {
        text = `${pct}% de redução no encerramento de processos entre ${m0} e ${m1}.`;
      } else {
        text = `Encerramento de Processos estável entre ${m0} e ${m1}, similar aos meses anteriores.`;
      }
      return { text };
    },
    /** Caixa Média Mensal (page9): ano anterior da API; ano atual médio dos pontos do relatório. */
    encerramentoMensalMediaBox() {
      const page = this.pages.page9;
      const { prev } = yearAveragesFromPage(page);
      const cur = currentYearAverageFromManagerialSeries(page);
      const { yPrev, yCur } = yearLabelsFromPage(page);
      return {
        prevYear: yPrev,
        curYear: yCur,
        prevAvg: prev != null ? String(Math.round(prev)) : '—',
        curAvg: cur != null ? String(Math.round(cur)) : '—',
      };
    },
    /** Slide Encerramento Semanal (page10): último vs penúltimo (chartEncerramentoSemanal). */
    highlightsEncerramentoSemanal() {
      const page = this.pages.page10;
      if (!page || !page.labels || !page.series || !page.series.length) {
        return { pctLabel: '—', line2: 'Dados insuficientes para este destaque.' };
      }
      const s0 = page.series[0];
      const counts = s0.counts || [];
      const labels = page.labels;
      const len = Math.min(counts.length, labels.length);
      if (len < 2) {
        return { pctLabel: '—', line2: 'Dados insuficientes para este destaque.' };
      }
      const iPen = len - 2;
      const iUlt = len - 1;
      const a = countAt(s0, iPen);
      const b = countAt(s0, iUlt);
      const m0 = labels[iPen];
      const m1 = labels[iUlt];
      const { pct, kind } = pctChangeMeta(a, b);
      const pctLabel = kind === 'flat' && a === 0 && b === 0 ? '0%' : `${pct}%`;
      let line2;
      if (kind === 'up') {
        line2 = `de crescimento no encerramento de processos entre ${m0} e ${m1}.`;
      } else if (kind === 'down') {
        line2 = `de redução no encerramento de processos entre ${m0} e ${m1}.`;
      } else {
        line2 = `Encerramento de Processos estável entre ${m0} e ${m1}.`;
      }
      return { pctLabel, line2 };
    },
    /** Caixa Média Semanal (page10): médias anuais da API. */
    encerramentoSemanalMediaBox() {
      const page = this.pages.page10;
      const { prev, cur } = yearAveragesFromPage(page);
      const { yPrev, yCur } = yearLabelsFromPage(page);
      return {
        prevYear: yPrev,
        curYear: yCur,
        prevAvg: prev != null ? String(Math.round(prev)) : '—',
        curAvg: cur != null ? String(Math.round(cur)) : '—',
      };
    },
  },
  watch: {
    managerial: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.destroyCharts();
          this.initCharts();
        });
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  beforeDestroy() {
    this.destroyCharts();
  },
  methods: {
    destroyCharts() {
      this.charts.forEach((c) => c && c.destroy());
      this.charts = [];
    },
    prepareForPdf() {
      this.charts.forEach((chart, i) => {
        if (chart && typeof chart.toBase64Image === 'function') {
          const dataUrl = chart.toBase64Image('image/png');
          this.$set(this.chartImages, CHART_REF_NAMES[i], dataUrl);
        }
      });
      this.pdfMode = true;
      return this.$nextTick();
    },
    resetAfterPdf() {
      this.pdfMode = false;
      this.chartImages = {};
    },
    initCharts() {
      if (this.$refs.chartMensal) this.chartMensal(this.$refs.chartMensal);
      if (this.$refs.chartDonutFev) this.chartDonutFev(this.$refs.chartDonutFev);
      if (this.$refs.chartDonutMar) this.chartDonutMar(this.$refs.chartDonutMar);
      if (this.$refs.chartSemanal) this.chartSemanal(this.$refs.chartSemanal);
      if (this.$refs.chartEvolucao) this.chartEvolucao(this.$refs.chartEvolucao);
      if (this.$refs.chartMensalAnalista) this.chartMensalAnalista(this.$refs.chartMensalAnalista);
      if (this.$refs.chartMensalCustomsTeam) this.chartMensalCustomsTeam(this.$refs.chartMensalCustomsTeam);
      if (this.$refs.chartMensalCustomsTeamPrime) this.chartMensalCustomsTeamPrime(this.$refs.chartMensalCustomsTeamPrime);
      if (this.$refs.chartSemanalAnalista) this.chartSemanalAnalista(this.$refs.chartSemanalAnalista);
      if (this.$refs.chartAberturaMensal) this.chartAberturaMensal(this.$refs.chartAberturaMensal);
      if (this.$refs.chartAberturaSemanal) this.chartAberturaSemanal(this.$refs.chartAberturaSemanal);
      if (this.$refs.chartEncerramentoMensal) this.chartEncerramentoMensal(this.$refs.chartEncerramentoMensal);
      if (this.$refs.chartEncerramentoSemanal) this.chartEncerramentoSemanal(this.$refs.chartEncerramentoSemanal);
      if (this.$refs.chartChegadas) this.chartChegadas(this.$refs.chartChegadas);
    },
    chartMensal(canvas) {
      const page = this.pages.page1;
      if (!page || !page.labels || !page.series) return;
      const datasets = page.series.map((s) => ({
        label: s.label,
        data: [...(s.counts || [])],
        backgroundColor: pickColor(s.color, COLORS.outras),
        borderRadius: 4,
      }));
      const yMax = niceCeilMax(maxInArrays(page.series.map((s) => s.counts)), 140);
      const step = yMax <= 80 ? 20 : yMax <= 160 ? 20 : Math.max(20, Math.ceil(yMax / 6 / 10) * 10);
      const labelsMensal = page.labels.map((label, i) => `${label} (${monthGrandTotal(page, i)})`);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels: labelsMensal, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 15, weight: '600' }, color: '#333' } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 12 }, color: '#666' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 2, font: { size: 13, weight: '700' }, color: '#333', formatter: (v) => v },
          },
        },
      });
      this.charts.push(c);
    },
    chartDonutFev(canvas) {
      const page = this.pages.page2;
      if (!page || !page.series || !page.labels || page.labels.length < 1) return;
      const idx = 0;
      const labels = page.series.map((s) => s.label);
      const data = page.series.map((s) => (s.counts && s.counts[idx] != null ? s.counts[idx] : 0));
      const backgroundColor = page.series.map((s) => pickColor(s.color, COLORS.outras));
      const c = createManagerialDonutChart(canvas, labels, data, backgroundColor);
      this.charts.push(c);
    },
    chartDonutMar(canvas) {
      const page = this.pages.page2;
      if (!page || !page.series || !page.labels || page.labels.length < 2) return;
      const idx = 1;
      const labels = page.series.map((s) => s.label);
      const data = page.series.map((s) => (s.counts && s.counts[idx] != null ? s.counts[idx] : 0));
      const backgroundColor = page.series.map((s) => pickColor(s.color, COLORS.outras));
      const c = createManagerialDonutChart(canvas, labels, data, backgroundColor);
      this.charts.push(c);
    },
    chartSemanal(canvas) {
      const page = this.pages.page3;
      if (!page || !page.labels || !page.series) return;
      const extra = page.labelsExtra || [];
      const labels = page.labels.map((l, i) => {
        const total = String(monthGrandTotal(page, i));
        const e = extra[i];
        if (e != null && String(e).trim() !== '') return [l, String(e), total];
        return [l, total];
      });
      const datasets = page.series.map((s) => ({
        label: s.label,
        data: [...(s.counts || [])],
        backgroundColor: pickColor(s.color, COLORS.outras),
        borderRadius: 3,
      }));
      const yMax = niceCeilMax(maxInArrays(page.series.map((s) => s.counts)), 35);
      const step = Math.max(5, Math.ceil(yMax / 7 / 5) * 5);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333', maxRotation: 0 } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 1, font: { size: 10, weight: '700' }, color: '#333', formatter: (v) => (v == null ? '' : v) },
          },
        },
      });
      this.charts.push(c);
    },
    chartEvolucao(canvas) {
      const page = this.pages.page4;
      if (!page || !page.labels || !page.series || !page.series.length) return;
      const extra = page.labelsExtra || [];
      const labels = page.labels.map((l, i) => {
        const e = extra[i];
        if (e != null && String(e).trim() !== '') return [l, String(e)];
        return l;
      });
      const s0 = page.series[0];
      const data = [...(s0.counts || [])];
      const lineColor = pickColor(s0.color, COLORS.navy);
      const yMax = niceCeilMax(maxInArrays([data]), 25);
      const step = Math.max(5, Math.ceil(yMax / 5 / 5) * 5);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: {
          labels,
          datasets: [{
            data,
            borderColor: lineColor,
            backgroundColor: 'transparent',
            borderWidth: 3,
            tension: 0.4,
            pointRadius: 5,
            pointBackgroundColor: lineColor,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            fill: false,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { color: '#e8e8e8' }, ticks: { font: { size: 14, weight: '600' }, color: '#333' } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 12 }, color: '#666' } },
          },
          plugins: {
            datalabels: {
              anchor: 'center',
              align: 'top',
              offset: 8,
              font: { size: 12, weight: '700' },
              color: '#333',
              formatter: (v) => (v == null || v === '' ? '' : v),
            },
          },
        },
      });
      this.charts.push(c);
    },
    chartMensalAnalista(canvas) {
      const page = this.pages.page5;
      if (!page || !page.labels || !page.series) return;
      const datasets = page.series.map((s) => ({
        label: s.label,
        data: [...(s.counts || [])],
        backgroundColor: pickColor(s.color, COLORS.imp1),
        borderRadius: 4,
      }));
      const yMax = niceCeilMax(maxInArrays(page.series.map((x) => x.counts)), 80);
      const step = Math.max(10, Math.ceil(yMax / 4 / 10) * 10);
      const labelsMensalAnalista = page.labels.map((label, i) => `${label} (${monthGrandTotal(page, i)})`);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels: labelsMensalAnalista, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333' } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 2, font: { size: 12, weight: '700' }, color: '#333', formatter: (v) => v },
          },
        },
      });
      this.charts.push(c);
    },
    chartMensalCustomsTeam(canvas) {
      this.chartMensalCustomsTeamBase(canvas, this.pages.page12);
    },
    chartMensalCustomsTeamPrime(canvas) {
      this.chartMensalCustomsTeamBase(canvas, this.pages.page13);
    },
    chartMensalCustomsTeamBase(canvas, page) {
      if (!page || !page.labels || !page.series) return;
      const datasets = page.series.map((s) => ({
        label: s.label,
        data: [...(s.counts || [])],
        backgroundColor: pickColor(s.color, COLORS.imp3),
        borderRadius: 4,
      }));
      const yMax = niceCeilMax(maxInArrays(page.series.map((x) => x.counts)), 80);
      const step = Math.max(10, Math.ceil(yMax / 4 / 10) * 10);
      const labelsMensal = page.labels.map((label, i) => `${label} (${monthGrandTotal(page, i)})`);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels: labelsMensal, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333' } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 2, font: { size: 12, weight: '700' }, color: '#333', formatter: (v) => v },
          },
        },
      });
      this.charts.push(c);
    },
    chartSemanalAnalista(canvas) {
      const page = this.pages.page6;
      if (!page || !page.labels || !page.series) return;
      const extra = page.labelsExtra || [];
      const labels = page.labels.map((l, i) => {
        const total = String(monthGrandTotal(page, i));
        const e = extra[i];
        if (e != null && String(e).trim() !== '') return [l, String(e), total];
        return [l, total];
      });
      const datasets = page.series.map((s) => ({
        label: s.label,
        data: [...(s.counts || [])],
        backgroundColor: pickColor(s.color, COLORS.imp1),
        borderRadius: 3,
      }));
      const yMax = niceCeilMax(maxInArrays(page.series.map((x) => x.counts)), 26);
      const step = Math.max(5, Math.ceil(yMax / 6 / 5) * 5);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333', maxRotation: 0 } },
            y: { min: 0, max: yMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 1, font: { size: 9, weight: '700' }, color: '#333', formatter: (v) => (v == null ? '' : v) },
          },
        },
      });
      this.charts.push(c);
    },
    chartAberturaMensal(canvas) {
      const page = this.pages.page7;
      if (!page || !page.labels || !page.series || !page.series.length) return;
      const counts = page.series[0].counts || [];
      const barColors = counts.map((_, i) => (i === counts.length - 1 ? COLORS.pink : COLORS.navy));
      const { xMax, step } = horizontalBarAxisScale(counts, 320, 50);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: [...page.labels],
          datasets: [{ data: [...counts], backgroundColor: barColors, borderRadius: 8, barThickness: 32 }],
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { min: 0, max: xMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 12 }, color: '#666' } },
            y: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 8, font: { size: 15, weight: '700' }, color: '#333', formatter: (v) => v },
          },
        },
      });
      this.charts.push(c);
    },
    chartAberturaSemanal(canvas) {
      const page = this.pages.page8;
      if (!page || !page.labels || !page.series || !page.series.length) return;
      const extra = page.labelsExtra || [];
      const labels = page.labels.map((l, i) => {
        const e = extra[i];
        if (e != null && String(e).trim() !== '') return [l, String(e)];
        return l;
      });
      const counts = page.series[0].counts || [];
      const xMax = niceCeilMax(maxInArrays([counts]), 130);
      const step = Math.max(20, Math.ceil(xMax / 6 / 20) * 20);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels, datasets: [{ data: [...counts], backgroundColor: COLORS.amber, borderRadius: 6, barThickness: 28 }] },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { min: 0, max: xMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
            y: { grid: { display: false }, ticks: { font: { size: 13, weight: '500' }, color: '#333' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 6, font: { size: 12, weight: '700' }, color: '#333', formatter: (v) => (v == null ? '' : v) },
          },
        },
      });
      this.charts.push(c);
    },
    chartEncerramentoMensal(canvas) {
      const page = this.pages.page9;
      if (!page || !page.labels || !page.series || !page.series.length) return;
      const counts = page.series[0].counts || [];
      const barColors = counts.map((_, i) => (i === counts.length - 1 ? COLORS.pink : COLORS.navy));
      const { xMax, step } = horizontalBarAxisScale(counts, 260, 50);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: [...page.labels],
          datasets: [{ data: [...counts], backgroundColor: barColors, borderRadius: 8, barThickness: 32 }],
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { min: 0, max: xMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 12 }, color: '#666' } },
            y: { grid: { display: false }, ticks: { font: { size: 14, weight: '600' }, color: '#333' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 8, font: { size: 15, weight: '700' }, color: '#333', formatter: (v) => v },
          },
        },
      });
      this.charts.push(c);
    },
    chartEncerramentoSemanal(canvas) {
      const page = this.pages.page10;
      if (!page || !page.labels || !page.series || !page.series.length) return;
      const extra = page.labelsExtra || [];
      const labels = page.labels.map((l, i) => {
        const e = extra[i];
        if (e != null && String(e).trim() !== '') return [l, String(e)];
        return l;
      });
      const counts = page.series[0].counts || [];
      const xMax = niceCeilMax(maxInArrays([counts]), 85);
      const step = Math.max(20, Math.ceil(xMax / 5 / 20) * 20);
      const c = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: { labels, datasets: [{ data: [...counts], backgroundColor: COLORS.amber, borderRadius: 6, barThickness: 28 }] },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { min: 0, max: xMax, grid: { color: '#e8e8e8' }, ticks: { stepSize: step, font: { size: 11 }, color: '#666' } },
            y: { grid: { display: false }, ticks: { font: { size: 13, weight: '500' }, color: '#333' } },
          },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 6, font: { size: 12, weight: '700' }, color: '#333', formatter: (v) => (v == null ? '' : v) },
          },
        },
      });
      this.charts.push(c);
    },
    chartChegadas(canvas) {
      const page = this.pages.page11;
      if (!page || !page.series) return;
      const labels = page.series.map((s) => s.label);
      const data = page.series.map((s) => (s.counts && s.counts[0] != null ? s.counts[0] : 0));
      const backgroundColor = page.series.map((s) => pickColor(s.color, COLORS.imp1));
      const c = new Chart(canvas.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels,
          datasets: [{ data, backgroundColor, borderWidth: 2, borderColor: '#fff' }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '52%',
          layout: { padding: 70 },
          plugins: {
            datalabels: { anchor: 'end', align: 'end', offset: 14, font: { size: 14, weight: '700' }, color: '#333', formatter: (value, ctx) => ctx.chart.data.labels[ctx.dataIndex] + '\n' + value, textAlign: 'center' },
          },
        },
      });
      this.charts.push(c);
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=League+Spartan:wght@400..900&display=swap');
</style>

<style scoped>
.indicadores-report {
  font-family: 'Poppins', Arial, sans-serif;
  color: #222;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.slide {
  width: 1280px;
  height: 720px;
  background: #ffffff;
  margin: 0;
  position: relative;
  overflow: hidden;
  /* page-break-after: always;
  break-after: page; */
}

.slide-capa {
  padding: 0;
  position: relative;
  overflow: hidden;
}

.capa-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.slide-inner {
  box-sizing: border-box;
}

.slide-flex {
  display: flex;
}

.title-main {
  font-family: 'League Spartan', 'Poppins', Arial, sans-serif;
  font-size: 60px;
  font-weight: 700;
  color: #1B2A6B;
  text-align: center;
  padding-top: 14px;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.title-main-dis-duimp {
  color: #1D5ACB;
}

.title-sub {
  font-family: 'League Spartan', 'Poppins', Arial, sans-serif;
  font-size: 60px;
  font-weight: 700;
  color: #C9930F;
  text-align: center;
  margin-top: 0;
  line-height: 1.2;
}

.legend {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  font-weight: 500;
  color: #222;
}

.legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 4px solid;
  box-sizing: border-box;
  background-repeat: no-repeat;
  /* Mesmo enquadramento do antigo object-fit cover + object-position (html2canvas trata melhor background). */
  background-size: cover;
  background-position: center 22%;
}

.modify-slide {
 height: 800px !important;
}
.legend-avatar--adriani {
  background-image: url('~@/assets/time/adriani-v3.png');
}
.legend-avatar--mariane {
  background-image: url('~@/assets/time/mariane-v3.png');
}
.legend-avatar--felipe {
  background-image: url('~@/assets/time/felipe-v3.png');
}
.legend-avatar--cami {
  background-image: url('~@/assets/time/camila-v3.png');
}
.legend-avatar--camila {
  background-image: url('~@/assets/time/camila-v3.png');
}
.legend-avatar--maria-gabriela {
  background-image: url('~@/assets/time/maria-gabriela-v3.png');
}
.legend-avatar--laura {
  background-image: url('~@/assets/time/laura-v3.png');
}

.highlight-box {
  border-radius: 12px;
  padding: 18px 22px;
  color: white;
}

.highlight-box .big-pct {
  font-size: 56px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 8px;
}

.highlight-box .small-text {
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;
}

.box-navy { background: #1B2A6B; }
.box-bright-blue { background: #2B6BDB; }

.chart-pdf-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

@media print {
  .slide {
    margin: 0;
    /* page-break-after: always;
    break-after: page; */
  }
}
</style>
